/* components/Dropdown.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	create_slot,
	detach,
	element,
	get_slot_changes,
	get_slot_context,
	init,
	insert,
	listen,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import { createEventDispatcher } from "svelte";

function create_fragment(ctx) {
	let details;
	let summary;
	let t0;
	let t1;
	let div0;
	let summary_class_value;
	let t2;
	let div1;
	let current;
	let dispose;
	const default_slot_template = /*$$slots*/ ctx[8].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[7], null);

	return {
		c() {
			details = element("details");
			summary = element("summary");
			t0 = text(/*buttonText*/ ctx[0]);
			t1 = space();
			div0 = element("div");
			t2 = space();
			div1 = element("div");
			if (default_slot) default_slot.c();
			attr(div0, "class", "dropdown-caret");
			attr(summary, "class", summary_class_value = `btn ${/*buttonClass*/ ctx[1]}`);
			attr(summary, "aria-haspopup", "true");
			attr(div1, "class", "dropdown-menu dropdown-menu-sw width-auto p-3");
			attr(details, "class", "dropdown details-reset details-overlay d-inline-block");
		},
		m(target, anchor, remount) {
			insert(target, details, anchor);
			append(details, summary);
			append(summary, t0);
			append(summary, t1);
			append(summary, div0);
			append(details, t2);
			append(details, div1);

			if (default_slot) {
				default_slot.m(div1, null);
			}

			/*details_binding*/ ctx[9](details);
			current = true;
			if (remount) dispose();
			dispose = listen(summary, "click", /*handleToggleOpen*/ ctx[3]);
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*buttonText*/ 1) set_data(t0, /*buttonText*/ ctx[0]);

			if (!current || dirty & /*buttonClass*/ 2 && summary_class_value !== (summary_class_value = `btn ${/*buttonClass*/ ctx[1]}`)) {
				attr(summary, "class", summary_class_value);
			}

			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 128) {
					default_slot.p(get_slot_context(default_slot_template, ctx, /*$$scope*/ ctx[7], null), get_slot_changes(default_slot_template, /*$$scope*/ ctx[7], dirty, null));
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(details);
			if (default_slot) default_slot.d(detaching);
			/*details_binding*/ ctx[9](null);
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { buttonText } = $$props;
	let { buttonClass = "btn-sm" } = $$props;
	const dispatch = createEventDispatcher();
	let open = false;
	let detailsEl;

	const handleToggleOpen = () => {
		if (open) {
			open = false;
			dispatch("closed");
		} else {
			open = true;
			dispatch("opened");
		}
	};

	const close = () => $$invalidate(2, detailsEl.open = false, detailsEl);
	let { $$slots = {}, $$scope } = $$props;

	function details_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			$$invalidate(2, detailsEl = $$value);
		});
	}

	$$self.$set = $$props => {
		if ("buttonText" in $$props) $$invalidate(0, buttonText = $$props.buttonText);
		if ("buttonClass" in $$props) $$invalidate(1, buttonClass = $$props.buttonClass);
		if ("$$scope" in $$props) $$invalidate(7, $$scope = $$props.$$scope);
	};

	return [
		buttonText,
		buttonClass,
		detailsEl,
		handleToggleOpen,
		close,
		open,
		dispatch,
		$$scope,
		$$slots,
		details_binding
	];
}

class Dropdown extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { buttonText: 0, buttonClass: 1, close: 4 });
	}

	get close() {
		return this.$$.ctx[4];
	}
}

export default Dropdown;